<template>
<div>
  <div class="box">
    <div class="box_f1">
      <!-- 基本信息 开始-->
      <basic-info-card
        title="基本信息"
        width="1145px"
        :content_obj="content_obj"
        :isEditMode="baseEditMode"
        :rownumber="rownumber"
        :maxlength="maxlength"
        :imgArr="imgArr"
        :imgNumber="imgNumber"
        @delImgArr="delImgArr"
      >
        <div class="box" slot="right">
          <div class="delete-text" v-if="baseEditMode" @click="cancelBaseEdit">取消</div>
          <Button
            class="btn-size header-button"
            type="primary"
            @click="saveEdit"
          >{{baseEditMode?'保存':'编辑'}}</Button>
        </div>
      </basic-info-card>

      <!-- 设置  开始-->
      <basic-info-card
        title="设置"
        width="1145px"
        height="100px"
        :content_obj="setting_info"
        :isEditMode="false"
        tip="点击绑定按钮后，请使用公众号管理员微信扫码绑定"
      >
        <div class="box" slot="right">
          <Button
            v-if="!isAuthority"
            @click="authority"
            class="header-button"
            type="primary"
          >绑定本单位公众号</Button>
          <Button
            v-else
            type="primary"
            class="btn-yellow btn-size header-button"
            @click="opendelgzhModel"
          >注销</Button>
        </div>
      </basic-info-card>
      <Modal v-model="delgzhModel" width="360">
        <p slot="header" style="color:#f60;text-align:center">
          <Icon type="information-circled"></Icon>
          <span>删除确认</span>
        </p>
        <div style="text-align:center">
          <p>删除后系统的公众号菜单设置将清除，系统中其他数据不受影响</p>
        </div>
        <div slot="footer">
          <Button type="error" size="large" long @click="delgzh">删除</Button>
        </div>
      </Modal>
      <!-- 设置  结束-->
      <!-- 回复设置 -->
      <Card class="basic_card reply_card" :padding="0">
        <div slot="title" class="card_title">
          <span class="card-title-text">自动回复</span>
          <Tooltip
            content="点击绑定按钮后，请使用公众号管理员微信扫码绑定"
            placement="bottom-start"
            class="tootip"
            max-width="200"
          >
            <Icon type="ios-help-circle-outline" size="16" color="#6a6a6a" class="card-title-icon"/>
          </Tooltip>
        </div>
        <!-- 关注回复 开始-->
        <div class="reply_box">
          <div class="reply_title_between box">
            <div class="box ac">
              <Icon custom="iconfont icon-xin" size="14"/>
              <p class="reply-title-text">关注回复</p>
            </div>
            <div class="box ac" v-if="isAuthority">
              <div
                class="extra-cancel delete-text"
                v-show="focusReply.editMode"
                @click="cancelEdit('focusReply')"
              >取消</div>
              <Button
                class="edit-button right_button btn-size"
                @click="edit('focusReply')"
              >{{focusReply.editMode?'保存':'编辑'}}</Button>
            </div>
          </div>
          <div class="reply_content box ac" v-if="isAuthority">
            <div v-show="!focusReply.editMode">{{focusReply.content[0].nameValue || '未设置回复语'}}</div>
            <Input
              type="textarea"
              class="editarea"
              :rows="4"
              :autosize="true"
              :maxlength="200"
              v-model="replycontent"
              v-show="focusReply.editMode"
            />
          </div>
          <div v-else class="reply_content box ac delete-text">绑定公众号后可设置</div>
          <div
            class="box ac delete-text"
            v-if="replyMaxLength && isAuthority && focusReply.editMode"
            style="margin-left:42px"
          >*最多可输入200个字</div>
        </div>
        <!-- 关注回复 结束-->
        <div class="reply_box">
          <div class="reply_title box">
            <Icon custom="iconfont icon-pinglun3" size="16"/>
            <p class="reply-title-text">消息回复</p>
          </div>
          <div class="reply_content box ac delete-text">消息回复功能正在开发</div>
        </div>
        <div class="reply_box">
          <div class="reply_title box">
            <Icon custom="iconfont icon-geci" size="16"/>
            <p class="reply-title-text">关键词</p>
          </div>
          <div class="reply_content box ac delete-text">关键词回复功能正在开发</div>
        </div>
      </Card>
    </div>
    <div class="right box">
      <Card class="wechat_card" dis-hover>
        <div slot="title">
          <p>
            菜单设置
            <svg
              class="title-icon"
              aria-hidden="true"
              style="float:right;margin-right:81%;width:14px;height:14px;margin-top:3px;"
            >
              <use xlink:href="#icon-wenhao"></use>
            </svg>
          </p>
          <div v-if="isDownloadCode" style="float: right;margin-top: -27px;">
            <Poptip trigger="hover" placement="bottom">
              <Button type="text">公众号二维码</Button>
              <div v-if="isCreateCode" class="api" slot="content">
                <img
                  style="width: 100px;height: 100px; margin:0 auto; display:block"
                  :src="shequCode"
                >
                <div style="text-align: center;">
                  <Button type="text" @click="downloadCode" size="small">下载</Button>
                </div>
              </div>
              <div v-else class="api" slot="content">
                <div v-if="codeType == 0" style="width: 100px;height: 140px;">
                  <img v-if="shequCode" style="width: 100px;height: 100px;" :src="shequCode">
                  <div v-else>
                    <div style="height: 116px;line-height: 116px;text-align: center">请上传二维码</div>
                    <div class="btnUploadCode" @click="triggerUploadBtn">
                      电脑上传
                      <input
                        type="file"
                        name
                        ref="uploadCode"
                        id="file"
                        style="display: none"
                        @change="imgChange"
                      >
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  style="width: 100px;height: 140px;margin-left: 10px;line-height: 140px;cursor: pointer"
                  @click="getloadCode"
                >
                  <span>
                    <Icon type="refresh"></Icon>
                  </span>
                  重新获取二维码
                </div>
              </div>
            </Poptip>
          </div>
          <div v-else>
            <Button disabled type="text" style="float: right;margin-top: -27px;">下载二维码</Button>
          </div>
        </div>
        <div class="menubox box">
          <div class="keyboard box">
            <div class="iconfont icon-weixinjianpan"></div>
          </div>
          <div
            class="menu-name menu box_f1"
            v-for="(menu,menuindex) in menuData"
            v-bind:key="menuindex"
          >
            <div class="box primarymenu">
              <div class="iconfont icon-icon-" @click="editorMenu(menu)"></div>
              <div @click="showNavMenu(menu,menuindex)">{{menu.name}}</div>
            </div>

            <div class="navmenu-add" :class="{hide: menu.isHideNavMenu}" @dragover="allowDrop">
              <div
                class="navmenu-li"
                :class="{'navmenu-small': menuCount>1}"
                :id="index"
                draggable="true"
                @drop="drop(menu,index)"
                @dragstart="drag(index)"
                v-for="(navMenu,index) in menu.children"
                @click="editorNavMenu(navMenu,menu)"
                style="border-bottom: 1px solid #d7dde4;cursor: pointer;"
                :key="index"
              >{{navMenu.name}}</div>
              <div
                class="navmenu-li add"
                :class="{'navmenu-small': menuCount>1,'hide': menu.isHideAddNav}"
                @click="addNavMenu(menu)"
                style="-webkit-user-select:none;user-select:none;cursor: pointer;"
              >+</div>
            </div>
          </div>
          <div
            class="menu-add box_f1"
            @click="addMenu"
            :class="{hide: isHideAddMenu}"
            style=" -webkit-user-select:none;user-select:none;cursor: pointer"
          >+</div>
        </div>
      </Card>
      <Card
        :padding="0"
        v-show="modalNavMenu"
        style="width:580px; height:500px; position:fixed; z-index:200; top:50%; right:0;left:0;margin:0 auto; margin-top:-250px"
      >
        <p slot="title">{{modalNavMenuInfo.name}}</p>
        <Icon slot="extra" type="md-close" @click="closeEditCard" style="cursor: pointer"/>
        <div class="navMenu_card_body">
          <div v-if="isShowMenuName">
            <div style="color: #8d8d8d;padding-bottom: 10px;">已添加子菜单，仅可设置菜单名称。</div>
            <div class="modalLabel">
              <span style="font-size:18px">菜单名称</span>
              <Input
                v-model="modalNavMenuInfo.name"
                placeholder="请输入..."
                style="width: 300px;margin-left: 10px;"
              />
            </div>
            <div style="margin-left: 84px;font-size: 14px;color: #8d8d8d;">
              <span style="margin-left: 10px">字数不超过4个汉字或8个字母</span>
            </div>
          </div>
          <div v-else>
            <div class="modalLabel">
              <span v-if="isMenu">菜单名称</span>
              <span v-else>子菜单名称</span>
              <Input
                v-model="modalNavMenuInfo.name"
                placeholder="请输入..."
                style="width: 300px;margin-left: 10px;"
                :maxlength="16"
              />
            </div>
            <div style="margin-left: 84px;font-size: 14px;color: #8d8d8d;margin-top:6px;">
              <span v-if="isMenu">字数不超过4个汉字或8个字母</span>
              <span v-else>字数不超过8个汉字或16个字母</span>
            </div>
            <div style="margin-top: 10px">
              <span v-if="isMenu">菜单内容</span>
              <span v-else>子菜单内容</span>
              <Radio-group
                v-model="navMenuContent"
                @on-change="radioChange"
                style="margin-left: 10px"
              >
                <Radio label="view">
                  <span>跳转网页</span>
                </Radio>
                <!--<Radio label="click">
                    <span>事件推送</span>
                </Radio>-->
                <Radio label="miniprogram">
                  <span>小程序</span>
                </Radio>
              </Radio-group>
              <div style="margin: 0 auto;">
                <div :class="{hide: navMenuContent !== 'view'}" style="padding: 16px 0;">
                  <div style="color: #8d8d8d;padding-bottom: 10px;">订阅者点击该子菜单会跳到以下链接</div>
                  <div class>链接地址
                    <Input
                      v-model="modalNavMenuInfo.url"
                      placeholder="请输入..."
                      style="width: 300px;margin-left: 10px;"
                    />
                  </div>
                </div>
                <div :class="{hide: navMenuContent !== 'click'}" style="padding: 16px 20px;">
                  <div>
                    <Radio-group v-model="modalNavMenuInfo.location">
                      <div>
                        <Radio
                          v-for="(eventItem,index) in eventTuiSong"
                          :label="eventItem.url"
                          :key="index"
                        >
                          <span>{{eventItem.title}}</span>
                        </Radio>
                      </div>
                    </Radio-group>
                  </div>
                </div>
                <div :class="{hide: navMenuContent !== 'miniprogram'}" style="padding: 16px 0;">
                  <div style="color: #8d8d8d;">请选择小程序</div>
                  <div style="margin-top: 10px">
                    <Radio-group v-model="modalNavMenuInfo.pagepath">
                      <div>
                        <Radio v-for="(item,index) in xiaoChengXu" :label="item.url" :key="index">
                          <span>{{item.title}}</span>
                        </Radio>
                      </div>
                    </Radio-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="navMenu_card_footer box">
          <Poptip v-model="isVisibleMenuPop" placement="top-end" style="font-weight: 500;">
            <span v-if="isMenu">
              <a v-if="!isMyMenu">删除菜单</a>
            </span>
            <span v-else>
              <a>删除子菜单</a>
            </span>
            <div slot="title">
              <p style="text-align: left;font-weight: 500">您确认删除这条内容吗？</p>
            </div>
            <div slot="content" style>
              <p style="font-size: 12px;font-weight: 500">删除后“{{modalNavMenuInfo.name}}”菜单下设置的内容将被删除</p>
              <div style="text-align: right;">
                <Button type="text" @click="cancelDel">取消</Button>
                <Button
                  v-if="isMenu"
                  type="primary"
                  @click="delMenu(modalNavMenuInfo)"
                  class="btn-size"
                >确定</Button>
                <Button v-else type="primary" @click="delNavMenu" class="btn-size">确定</Button>
              </div>
            </div>
          </Poptip>
          <Button type="primary" @click="saveMenu" class="btn-size">确认提交</Button>
        </div>
      </Card>

      <Modal v-model="modalNavMenu" width="580" class="hide">
        <p slot="header" style>{{modalNavMenuInfo.name}}</p>
        <div v-if="isShowMenuName">
          <div style="color: #8d8d8d;padding-bottom: 10px;">已添加子菜单，仅可设置菜单名称。</div>
          <div class="modalLabel">菜单名称
            <Input
              v-model="modalNavMenuInfo.name"
              placeholder="请输入..."
              style="width: 300px;margin-left: 10px;"
            />
          </div>
          <div style="margin-left: 74px;font-size: 14px;color: #8d8d8d;">
            <span>字数不超过4个汉字或8个字母</span>
          </div>
        </div>
        <div style v-else>
          <div class="modalLabel">
            <span v-if="isMenu">菜单名称</span>
            <span v-else>子菜单名称</span>
            <Input
              v-model="modalNavMenuInfo.name"
              placeholder="请输入..."
              style="width: 300px;margin-left: 10px;"
              :maxlength="16"
            />
          </div>
          <div style="margin-left: 74px;font-size: 14px;color: #8d8d8d;margin-top:6px;">
            <span v-if="isMenu">字数不超过4个汉字或8个字母</span>
            <span v-else>字数不超过8个汉字或16个字母</span>
          </div>
          <div style="margin-top: 10px">
            <span v-if="isMenu">菜单内容</span>
            <span v-else>子菜单内容</span>
            <Radio-group
              v-model="navMenuContent"
              @on-change="radioChange"
              style="margin-left: 10px"
            >
              <Radio label="view">
                <span>跳转网页</span>
              </Radio>
              <!--<Radio label="click">
                                <span>事件推送</span>
              </Radio>-->
              <Radio label="miniprogram">
                <span>小程序</span>
              </Radio>
            </Radio-group>
          </div>
          <div style="margin: 0 auto;">
            <div :class="{hide: navMenuContent !== 'view'}" style="padding: 16px 0;">
              <div style="color: #8d8d8d;padding-bottom: 10px;">订阅者点击该子菜单会跳到以下链接</div>
              <div class>链接地址
                <Input
                  v-model="modalNavMenuInfo.url"
                  placeholder="请输入..."
                  style="width: 300px;margin-left: 10px;"
                />
              </div>
              <!--<div style="margin-top: 10px;">
                                <Radio-group v-model="modalNavMenuInfo.url">
                                    <div>
                                        <div style="font-weight: 700;margin-bottom: 5px;">常用链接</div>
                                        <Radio v-for="url in listmenuurl" :label="url.url"><span>{{url.title}}</span></Radio>
                                    </div>
                                    <div style="margin-top: 10px;">
                                        <div style="font-weight: 700;margin-bottom: 5px;">预存链接</div>
                                        <Radio v-for="preSavePage in preSavePages" :label="preSavePage.url">
                                            <span>{{preSavePage.title}}</span>
                                        </Radio>
              </div>-->
              <!--<div style="margin-top: 10px;">-->
              <!--<div style="font-weight: 700;margin-bottom: 5px;">事件推送</div>-->
              <!--<Radio v-for="eventItem in eventTuiSong" :label="eventItem.url">-->
              <!--<span>{{eventItem.title}}</span>-->
              <!--</Radio>-->
              <!--</div>-->
              <!--<div style="margin-top: 10px;">-->
              <!--<div style="font-weight: 700;margin-bottom: 5px;">小程序</div>-->
              <!--<Radio v-for="item in xiaoChengXu" :label="item.url">-->
              <!--<span>{{item.title}}</span>-->
              <!--</Radio>-->
              <!--</div>-->
              <!--</Radio-group>
              </div>-->
            </div>
            <div :class="{hide: navMenuContent !== 'click'}" style="padding: 16px 20px;">
              <div>
                <Radio-group v-model="modalNavMenuInfo.location">
                  <div>
                    <!--<div style="font-weight: 700;margin-bottom: 5px;">事件推送</div>-->
                    <Radio
                      v-for="(eventItem,index) in eventTuiSong"
                      :label="eventItem.url"
                      :key="index"
                    >
                      <span>{{eventItem.title}}</span>
                    </Radio>
                  </div>
                  <!--<div style="margin-top: 10px;">-->
                  <!--<div style="font-weight: 700;margin-bottom: 5px;">小程序</div>-->
                  <!--<Radio v-for="item in xiaoChengXu" :label="item.url">-->
                  <!--<span>{{item.title}}</span>-->
                  <!--</Radio>-->
                  <!--</div>-->
                </Radio-group>
              </div>
            </div>
            <div :class="{hide: navMenuContent !== 'miniprogram'}" style="padding: 16px 0;">
              <!-- <div class="">链接地址    <Input v-model="modalNavMenuInfo.pagepath" placeholder="请输入..." style="width: 300px;margin-left: 10px;"></Input></div> -->
              <div style="margin-top: 10px">
                <Radio-group v-model="modalNavMenuInfo.pagepath">
                  <div>
                    <!--<div style="font-weight: 700;margin-bottom: 5px;">小程序</div>-->
                    <Radio v-for="(item,index) in xiaoChengXu" :label="item.url" :key="index">
                      <span>{{item.title}}</span>
                    </Radio>
                  </div>
                </Radio-group>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Poptip v-model="isVisibleMenuPop" placement="top-end" style="font-weight: 500;">
            <span v-if="isMenu">
              <a v-if="!isMyMenu">删除菜单</a>
            </span>
            <span v-else>
              <a>删除子菜单</a>
            </span>
            <div slot="title">
              <p style="text-align: left;font-weight: 500">您确认删除这条内容吗？</p>
            </div>
            <div slot="content" style>
              <p style="font-size: 12px;font-weight: 500">删除后“{{modalNavMenuInfo.name}}”菜单下设置的内容将被删除</p>
              <div style="text-align: right;">
                <Button type="text" @click="cancelDel">取消</Button>
                <Button v-if="isMenu" type="primary" @click="delMenu(modalNavMenuInfo)">确定</Button>
                <Button v-else type="primary" @click="delNavMenu">确定</Button>
              </div>
            </div>
          </Poptip>
          <Button type="success" size="large" @click="saveMenu" class="btn-submit">确认提交</Button>
        </div>
      </Modal>
    </div>
  </div>
  </div>
</template>

<script>
var that;
import basicInfoCard from "./components/basicInfoCard";
export default {
  name: "adminBasic",
  components: {
    basicInfoCard
  },
  watch: {
    replycontent() {
      if (this.replycontent.length === 200) {
        this.replyMaxLength = true;
      } else {
        this.replyMaxLength = false;
      }
    }
  },
  data() {
    return {
      replyMaxLength: false,
      imgArr: [], //图片列表
      imgNumber: 5, //图片最多传几张
      rownumber: 1,
      maxlength: 50,
      baseOriginContent: {},
      content_obj: {
        id: "",
        content_arr: [],
        isEditable: true
      }, // //基本信息
      baseEditMode: false, //基本信息编辑状态
      setting_info: {
        id: "",
        title: "",
        headpicture: "",
        content_arr: [],
        isEditable: true
      }, //设置信息
      autoResFlag: true,
      isHideAddMenu: false, //是否隐藏底菜加号
      isHideNavMenu: true, //是否隐藏子菜单
      isHideAddNav: false, //是否隐藏子菜单加号
      modalNavMenu: false, //是否显示编辑对话框
      isDownloadCode: true, //是否加载了二维码
      isCreateCode: false, //不知道干什么的

      menuData: [],
      menuCount: 0, //底菜单数

      autoResFlag: false,
      addFlag: true,
      modal1: false,
      ruleName: "",
      replayCon: "",
      WeChat: {
        name: "",
        orgId: "",
        appid: "",
        appSecret: "",
        id: "",
        answer: "",
        hyy: "",
        hyyid: 0,
        type: "",
        headImg: ""
      },
      tags: [],
      isSmallMenu: false,
      menuCount: 0,

      modalNavMenu: false,
      isMenu: true,
      isShowMenuName: true,
      modalNavMenuInfo: {},
      modalMenuInfo: {},
      navMenuContent: "view",
      preSavePage: "",
      preSavePages: [],
      isMyMenu: false,
      selectedArticle: {},
      isVisibleMenuPop: false,
      isDownloadCode: false,
      shequCode: "",
      json: {
        title: "微信设置"
      },
      listmenuurl: [],
      isAuthority: false,
      authorizationCode: "",
      delgzhModel: false,
      isCreateCode: false,
      codeErrorMessage: "",
      codeType: -1,
      dropDownVisible: false,
      gzhList: [],
      currentWX: {},
      selectedGZHID: -1,
      eventTuiSong: [],
      xiaoChengXu: [],

      editInfo: [],
      baseInfo: {
        editMode: false,
        id: "",
        content: []
      },
      // wechatInfo: [
      //   {
      //     name: "APPID：",
      //     nameValue: "wx459235hgdu2e8a6"
      //   },
      //   {
      //     name: "原始ID：",
      //     nameValue: "gh_e150acae19a6"
      //   },
      //   {
      //     name: "账号类型：",
      //     nameValue: "服务号"
      //   }
      // ],
      replycontent: "",
      focusReply: {
        editMode: false,
        content: [
          {
            nameValue: ""
          }
        ]
      }
    };
  },
  mounted() {
    console.log("mounted");
  },
  created: function() {
    console.log("created");
    let vm = this;
    that = this;
    // this.getGongzhonghao()
    this.getSysInfo();
    this.authorizationCode = this.$util.getQueryString("auth_code");
    if (this.authorizationCode) {
      console.log("--------queryAuth----------");
      this.queryAuth();
    } else {
      console.log("--------wxGet----------");
      this.wxGet();
      if (vm.$store.state.initid) {
        this.isDownloadCode = true;
      }

      //获取常用菜单
      //this.getMenuUrl();
      //this.getEventTuiSong();
      this.getXiaoChengXu();
      ////获取菜单
      //this.getMenu();
      ////
      //this.gethyy();
      ////
      //this.getloadCode();
    }
    //this.getUpGZH();
  },
  methods: {
    // getGongzhonghao() {
    //   var vm = this;
    //   var url = this.$store.state.serverHost + "wx/api/wx/get";

    //   this.$post(
    //     url,
    //     this.qs.stringify({
    //       communityid: this.$store.state.streetorcommunityid,
    //       // communitytype: this.$store.state.userInfo.streetorcommunity
    //       communitytype: this.$store.state.streetorcommunity
    //     })
    //   ).then(res => {
    //     var data = res.rows[0];
    //     if (data.head_img) {
    //       this.$store.commit("updateGZHhead", data.head_img);
    //     } else {
    //       this.$store.commit("updateGZHhead", "");
    //     }
    //     this.$store.commit("updateGZHname", data.gzhmingc);
    //   });
    // },
    delImgArr(index) {
      //删除封面图
      this.$Message.success("删除成功");
      this.imgArr.splice(index, 1);
    },
    //基本信息取消编辑
    cancelBaseEdit() {
      console.log(this.content_obj);
      console.log(this.baseOriginContent);
      this.baseEditMode = false;
    },
    //基本信息点击编辑或保存
    saveEdit() {
      if (this.baseEditMode) {
        this.baseEditMode = false;
        this.saveSysInfo();
        //this.$emit('saveInfo',this.content_obj)
      } else {
        //let content = this.content_arr
        //this.originContent = this.content_obj.content_arr;
        this.baseEditMode = true;
      }
    },
    //基本信息保存
    saveSysInfo() {
      var vm = this;
      vm.$post(this.urlobj.community, {
        slogan: this.content_obj.content_arr[2].content,
        introduction: this.content_obj.content_arr[3].content,
        sysName: this.content_obj.content_arr[1].content
      })
        .then(function(response) {
          vm.$Message.success("社区信息修改成功!");
          vm.$store.commit(
            "updateSystemName",
            vm.content_obj.content_arr[1].content
          );
        })
        .catch(function(error) {
          vm.$Message.error("社区信息修改失败");
          console.log(error);
        });
    },
    //基本信息获取
    getSysInfo() {
      var vm = this;
      var url = vm.urlobj.community;
      this.$get(url)
        .then(function(response) {
          let arr = [];
          arr.push({
            name: "行政区域",
            content: response.rows[0].communityName,
            isEditable: false
          });
          arr.push({
            name: "系统名称",
            content: response.rows[0].sysName,
            isEditable: true,
            maxlength: 20
          });

          arr.push({
            name: "社区口号",
            content: response.rows[0].slogan,
            isEditable: true,
            maxlength: 20
          });
          arr.push({
            name: "社区介绍",
            content: response.rows[0].introduction,
            isEditable: true,
            maxlength: 140
          });
          let obj = {
            id: response.rows[0].id,
            content_arr: arr,
            isEditable: true
          };
          vm.content_obj = obj;
          vm.baseOriginContent = obj;
          vm.getSysPic();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getSysPic: function() {
      this.$get(this.urlobj.getSysPic())
        .then(resp => {
          let arr = [];

          resp.rows.forEach(item => {
            let obj = {
              path: item.picPath,
              id: item.id,
              picId: item.picId
            };
            arr.push(obj);
          });
          this.imgArr = arr;
        })
        .catch(error => {});
    },
    getReply: function() {
      console.log("---------getReply----------");
      var vm = this;
      this.$get(this.urlobj.reply)
        .then(function(response) {
          vm.focusReply.editMode = false;
          vm.replycontent = response.rows[0].body;
          vm.focusReply.content[0] = {
            name: "关注回复",
            nameValue: response.rows[0].body,
            id: response.rows[0].id
          };
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveReply() {
      var vm = this;
      console.log("--------editInfo-----------");
      vm.focusReply.content[0].nameValue = vm.replycontent;

      // if (this.WeChat.orgId) {
        var vm = this;
        var url = this.urlobj.reply;
        this.$post(url, {
          body: vm.replycontent
        })
          .then(function(response) {
            console.log(response);
            vm.$Message.success("保存成功!");
            vm.focusReply.content[0].id = response.newPrimaryKeys.id;
          })
          .catch(function(error) {
            console.log(error);
            vm.$Message.error("保存失败!");
          });
      // } else {
      //   vm.$Message.error("请先绑定微信公众号!");
      // }
    },
    wxGet() {
      var vm = this;
      var url = this.urlobj.get;
      this.$get(url)
        .then(function(response) {
          if (response.rows[0]) {
            let obj = {
              id: response.rows[0].id,
              title: response.rows[0].gzhmingc,
              headpicture: response.rows[0].head_img,
              content_arr: [],
              isEditable: false
            };

            obj.content_arr.push({
              name: "APPID",
              content: response.rows[0].gzhappid
            });

            obj.content_arr.push({
              name: "原始ID",
              content: response.rows[0].initid
            });

            obj.content_arr.push({
              name: "账号类型",
              content: response.rows[0].gzhleixing == 2 ? "服务号" : "订阅号"
            });
            vm.setting_info = obj;
            vm.WeChat.name = response.rows[0].gzhmingc;
            vm.WeChat.orgId = response.rows[0].initid;
            vm.WeChat.appid = response.rows[0].gzhappid;
            vm.WeChat.id = response.rows[0].id;
            vm.WeChat.type =
              response.rows[0].gzhleixing == 2 ? "服务号" : "订阅号";
            vm.WeChat.headImg = response.rows[0].head_img;
            vm.$store.commit("updateGZHhead", response.rows[0].head_img || "");
            vm.$store.commit("updateGZHname", response.rows[0].gzhmingc);
            vm.shequCode = response.rows[0].qrcode_url;
            vm.isCreateCode = response.rows[0].qrcode_url ? true : false;
            vm.codeType = response.code; // 用接口的返回状态码 渲染页面 不是一个很好的做法
            //if(response.data.rows[0].status == ''){
            //    vm.isAuthority = false;
            //} else {
            //    vm.isAuthority = response.data.rows[0].status > -1;
            //}
            vm.isAuthority = response.rows[0].status == "0";
            vm.$store.state.initid = response.rows[0].initid;
            sessionStorage.initid = response.rows[0].initid;
            if (vm.$store.state.initid) {
              vm.isDownloadCode = true;
            }
            if (vm.WeChat.orgId && vm.WeChat.appid) {
              vm.autoResFlag = true;
            } else {
              vm.autoResFlag = false;
            }
            //获取预存页面
            //vm.getPreSavePageUrl();
            //获取菜单
            vm.getMenu();
            //vm.gethyy();
            vm.getReply();
            // vm.getloadCode();
          } else {
            //没有获取数据时
            vm.WeChat.name = "";
            vm.WeChat.orgId = "";
            vm.WeChat.appid = "";
            vm.WeChat.answer = "";
            vm.WeChat.id = "";
            vm.WeChat.headImg = "";
            vm.$store.state.initid = "";
            sessionStorage.initid = "";
            sessionStorage.uid = "";
            vm.autoResFlag = false;
            vm.isDownloadCode = false;
            vm.setting_info = {
              id: "",
              title: "",
              headpicture: "",
              content_arr: [],
              isEditable: true
            };
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    queryAuth() {
      console.log("----------queryAuth------------");
      var vm = this;
      this.$post(this.urlobj.queryAuth, {
        code: this.authorizationCode
      })
        .then(function(response) {
          var data = response.rows[0];
          if (response.rows.length) {
            vm.$store.commit("updateGZHhead", data.head_img);
            vm.$store.commit("updateGZHname", data.gzhmingc);
console.log('--------here-----------')
          } else {
            vm.$store.commit("updateGZHhead", "");
            vm.$store.commit("updateGZHname", "");
            console.log('--------here-1111----------')
            console.log(sessionStorage.GZHname)
            console.log(this.$store.state.GZHname)

          }
         

          let obj = {
            id: response.rows[0].id,
            title: this.$store.state.GZHname,
            headpicture: this.$store.state.GZHhead,
            content_arr: [],
            isEditable: false
          };

          obj.content_arr.push({
            name: "APPID",
            content: response.rows[0].gzhappid
          });

          obj.content_arr.push({
            name: "原始ID",
            content: response.rows[0].initid
          });

          obj.content_arr.push({
            name: "账号类型",
            content: response.rows[0].gzhleixing == 2 ? "服务号" : "订阅号"
          });
          vm.setting_info = obj;
          vm.WeChat.name = response.rows[0].gzhmingc;
          vm.WeChat.orgId = response.rows[0].initid;
          vm.WeChat.appid = response.rows[0].gzhappid;
          vm.WeChat.answer = response.rows[0].autoanswer;
          vm.WeChat.id = response.rows[0].id;
          vm.WeChat.type =
            response.rows[0].gzhleixing == 2 ? "服务号" : "订阅号";
          vm.WeChat.headImg = response.rows[0].head_img;
          vm.shequCode = response.rows[0].qrcode_url;
          vm.isCreateCode = response.rows[0].qrcode_url ? true : false;
          vm.codeType = response.code;
          //if (response.data.rows[0].status == '') {
          //    vm.isAuthority = false;
          //} else {
          //    vm.isAuthority = response.data.rows[0].status > -1;
          //}
          vm.isAuthority = response.rows[0].status == "0";
          vm.$store.state.initid = response.rows[0].initid;
          if (vm.WeChat.orgId && vm.WeChat.appid) {
            vm.autoResFlag = true;
          } else {
            vm.autoResFlag = false;
          }
          //获取预存页面
          //vm.getPreSavePageUrl();

          //授权后在执行
          if (vm.$store.state.initid) {
            vm.isDownloadCode = true;
          }

          //获取常用菜单
          //vm.getMenuUrl();
          //vm.getEventTuiSong();
          vm.getXiaoChengXu();
          //获取菜单
          vm.getMenu();
          //
          //vm.gethyy();
          vm.getReply();
          //
          // vm.getloadCode();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    gethyy: function() {
      var vm = this;
      var url = this.urlobj.reply;
      this.$get(url)
        .then(function(response) {
          console.log(response);
          vm.WeChat.hyy = response.rows[0].body;
          vm.WeChat.hyyid = response.rows[0].id;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getloadCode: function() {
      this.wxGet();
      // var vm = this;
      // this.$get(this.urlobj.getForeverCode, {
      //   initid: this.$store.state.initid,
      //   code: "SubCode"
      // })
      //   .then(function(response) {
      //     vm.shequCode = response.rows[0];
      //     vm.isCreateCode = true;
      //     //vm.isCreateCode = false;
      //   })
      //   .catch(function(error) {
      //     vm.isCreateCode = false;
      //     //	vm.codeErrorMessage = response.message;
      //     //	vm.codeType = response.code;
      //     console.log(error);
      //   });
    },
    downloadCode: function() {
      var that  = this
      window.open(
        that.urlobj.downloadAttachment +
        `?picPath=${that.shequCode}&picName=${
          that.setting_info.title
          }&token=${sessionStorage.getItem(
          "token"
        )}`
      );
      // window.open(
      //   this.$store.state.serverHost +
      //     "wx/api/wx/downSubCode?initid=" +
      //     vm.$store.state.initid +
      //     "&token=" +
      //     this.$store.state.access_token
      // );
    },

    edit(obj) {
      /* 保存信息 处于编辑模式的时候 点击保存*/
      if (this[obj].editMode) {
        this[obj].content.forEach((item, index) => {
          item.nameValue = this.editInfo[index];
        });
        this.editInfo = []; // 保存了清空
        if (obj == "baseInfo") this.saveSysInfo();
        if (obj == "focusReply") this.saveReply();
      } else {
        /* 非编辑模式 初始化编辑框的信息 */
        this.editInfo = this[obj].content.map(item => {
          return item.nameValue;
        });
      }
      this[obj].editMode = !this[obj].editMode;
    },
    cancelEdit(obj) {
      /* 退出编辑模式 */
      this[obj].editMode = false;
      this.editInfo = []; //退出后 清空
    },
    getMenu() {
      var vm = this;
      var url = this.urlobj.getMenu;
      this.$get(url)
        .then(resp => {
          console.log(resp.rows.length);
          if (resp.rows.length > 0) {
            vm.menuData = JSON.parse(resp.rows[0].menucontent);
            for (var i = 0; i < vm.menuData.length; i++) {
              vm.$set(vm.menuData[i], "isHideNavMenu", true);
            }
            var length = vm.menuData.length;
            vm.menuCount = length;
            vm.isHideAddMenu = length === 3;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    addMenu: function() {
      var length = this.menuData.length;
      this.menuCount = length + 1;
      if (length === 2) {
        this.isHideAddMenu = true;
      }
      if (length < 3) {
        var newMenu = {
          name: "一级菜单",
          isHideNavMenu: true,
          isHideAddNav: false,
          children: [],
          mediaid: "",
          type: "",
          url: "",
          location: "",
          pagepath: ""
        };
        this.menuData.push(newMenu);
      }
    },
    delMenu: function(menu) {
      this.modalNavMenu = false;
      this.menuData.splice(this.menuData.indexOf(menu), 1);
      this.menuCount = this.menuData.length;
      this.isHideAddMenu = false;
      this.saveMenuAjax();
    },
    showNavMenu(menu, menuindex) {
      console.log("---------showNavMenu---------");
      let flag = !menu.isHideNavMenu;
      for (var i = 0; i < this.menuData.length; i++) {
        //this.menuData[i].isHideNavMenu = true;
        if (i == menuindex) {
          this.$set(this.menuData[i], "isHideNavMenu", flag);
        } else {
          this.$set(this.menuData[i], "isHideNavMenu", true);
        }
      }
      menu.isHideNavMenu = flag;
      if (menu.isHideNavMenu && menu.children.length > 4) {
        this.$set(menu, "isHideAddNav", true);
      }
    },
    drop(menu, indexf) {
      event.preventDefault();
      //拖动dom的位置indext
      var indext = parseInt(event.dataTransfer.getData("indext"));
      //放下dom的位置indexf
      var tempt = menu.children[indext];
      if (indexf > indext) {
        //event.target.parentNode.insertBefore(el, event.target.nextSibling);//改变数组的顺序元素的位置就自动发生变化了
        for (var i = indext; i <= indexf; i++) {
          if (i == indexf) {
            //menu.children[i] = tempt;//将indext位置的数据放到indexf的位置上
            this.$set(menu.children, i, tempt);
          } else {
            //menu.children[i] = menu.children[i + 1];//将indext(不包括)到indexf(包括)之间的数据向前移
            this.$set(menu.children, i, menu.children[i + 1]);
          }
        }
      } else if (indexf < indext) {
        //event.target.parentNode.insertBefore(el, event.target);//改变数组的顺序元素的位置就自动发生变化了
        for (var j = indext; j >= indexf; j--) {
          if (j == indexf) {
            //menu.children[j] = tempt;//将indext位置的数据放到indexf的位置上
            this.$set(menu.children, j, tempt);
          } else {
            //menu.children[j] = menu.children[j - 1];
            this.$set(menu.children, j, menu.children[j - 1]);
          }
        }
      } else {
        return;
      }
      //拖动完成后调用保存接口
      this.saveMenuAjax();
    },
    saveMenuAjax() {
      //关闭modal
      this.modalNavMenu = false;
      var vm = this;
      var url = this.urlobj.saveMenu;
      this.$post(
        url,
        this.qs.stringify({
          wmenu: JSON.stringify(this.menuData)
        })
      )
        .then(function(response) {
          console.log(response);
          if (!response.data.isSucceed) {
            vm.$Message.error(response.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    allowDrop() {
      event.preventDefault();
    },
    drag(index) {
      event.dataTransfer.setData("indext", index);
    },

    addNavMenu: function(menu) {
      event.stopPropagation(); //阻止冒泡，不去触发showNavMenu方法
      if (!menu.children) {
        this.$set(menu, "children", []);
      }
      var navMenus = menu.children;
      var length = navMenus.length; // 当前子菜单个数
      menu.isHideAddNav = !(length < 4);
      // 新增的子菜单
      var newMenu = {
        name: "子菜单名称",
        children: [],
        mediaid: "",
        type: "",
        url: "",
        location: "",
        pagepath: ""
      };
      navMenus.push(newMenu);
    },
    editorNavMenu: function(navMenu, menu) {
      event.stopPropagation(); //阻止冒泡，不去触发showNavMenu方法
      this.modalNavMenu = true;
      this.modalNavMenuInfo = navMenu; // 子菜单的内容展示在modal中
      this.modalMenuInfo = menu; //记录下子菜单对应的一级菜单
      this.isMenu = false; // 是否点击的一级菜单
      this.isShowMenuName = false;

      this.navMenuContent = navMenu.type || "view";
    },
    saveMenu: function() {
      // 保存菜单内容
      if (this.isShowMenuName) {
        // 只能修改主菜单名字时
        this.modalNavMenuInfo.type = "";
        this.modalNavMenuInfo.mediaid = "";
        this.modalNavMenuInfo.url = "";
        this.modalNavMenuInfo.location = "";
        this.modalNavMenuInfo.pagepath = "";
      } else {
        this.modalNavMenuInfo.type = this.navMenuContent;
        this.modalNavMenuInfo.location =
          this.navMenuContent == "click" ? this.modalNavMenuInfo.location : "";
        this.modalNavMenuInfo.url =
          this.navMenuContent == "view" ? this.modalNavMenuInfo.url : "";
        this.modalNavMenuInfo.pagepath =
          this.navMenuContent == "miniprogram"
            ? this.modalNavMenuInfo.pagepath
            : "";
        if (this.navMenuContent == "view" && this.modalNavMenuInfo.url == "") {
          this.$Message.info("页面地址不能为空!");
          return;
        }
      }
      this.saveMenuAjax();
    },
    closeEditCard: function() {
      this.modalNavMenu = false;
    },
    editorMenu: function(menu) {
      //event.stopPropagation(); //阻止冒泡，不去触发showNavMenu方法
      this.modalNavMenu = true; //显示modal
      this.isMyMenu = false; //没有我的菜单了

      this.modalMenuInfo = menu;
      this.isMenu = true;
      if (!menu.children) {
        this.isShowMenuName = false;
      } else {
        if (menu.children.length > 0) {
          this.isShowMenuName = true;
        } else {
          this.isShowMenuName = false;
        }
      }
      this.modalNavMenuInfo = menu; // 一级菜单的内容展示在modal中
      this.navMenuContent = menu.type || "view";
    },
    cancelDel() {
      this.isVisibleMenuPop = false;
    },
    delNavMenu: function() {
      this.modalMenuInfo.children.splice(
        this.modalMenuInfo.children.indexOf(this.modalNavMenuInfo),
        1
      );
      this.isVisibleMenuPop = false;
      this.modalNavMenu = false;
      this.modalMenuInfo.isHideAddNav = false; //删除子菜单后将添加子菜单的按钮设置为可见
      this.saveMenuAjax();
    },
    cancelDel() {
      this.isVisibleMenuPop = false;
    },
    radioChange: function() {
      //console.log(this.navMenuContent);
    },
    getXiaoChengXu() {
      console.log("=======getXiaoChengXu========");
      var vm = this;
      var url = this.urlobj.listmenuurl;
      this.$get(url, {
        remark: "miniprogram"
      })
        .then(function(response) {
          vm.xiaoChengXu = response.rows;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //绑定本单位公众号
    authority() {
      this.$get(this.urlobj.getauthurl)
        .then(function(response) {
          // 拼接重定向的 hash 模式
          window.location.href =
            response.rows[0] + encodeURIComponent("/#/Administrator/basic");
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //解绑公众号
    opendelgzhModel() {
      this.delgzhModel = true;
    },
    delgzh() {
      let vm = this;
      this.$delete(this.urlobj.deleteGzh)
        .then(function(response) {
          console.log(response);
          vm.$Message.success("删除成功!");
          vm.$store.commit("updateGZHhead", "");
          vm.$store.commit("updateGZHname", "");

          vm.delgzhModel = false;
          vm.isAuthority = false;
          //获取微信基本信息
          vm.wxGet();
          //vm.getUpGZH();

          if (vm.$store.state.initid) {
            vm.isDownloadCode = true;
          }
          if (vm.menuData.length > 0) {
            vm.isSmallMenu = true;
          }
          if (vm.menuData.length > 1) {
            vm.isSmallMenu = true;
            vm.isHideAddMenu = true;
          }

          //获取常用菜单
          // vm.getMenuUrl();
          // vm.getEventTuiSong();
          // vm.getXiaoChengXu();
          // //获取菜单
          // vm.getMenu();
          // //
          // vm.gethyy();
          // //
          // vm.getloadCode();
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  computed: {}
};
</script>

<style scoped>
/* 编辑框样式 */
.editarea {
  width: 100%;
}
/* card style */
.basic_card {
  margin: 20px 0 0 30px;
  height: auto;
}
/* card 标题 基础 */
.card_title {
  color: #333;
  font-size: 16px;
}
/* card 标题 左侧文本 */
.card-title-text {
  margin-right: 10px;
}

/* card 标题 图标 */
.card-title-icon {
  cursor: help;
}
/* card extra style */
.extra-content {
  display: flex;
  align-items: center;
  margin-top: -0.5em;
}
/* card 右侧的取消文字 */
.extra-cancel {
  margin-right: 1em;
  cursor: pointer;
}

/* 右边的button */
.right_button {
  background-color: #ff5b35;
  color: #fff;
  border: none;
}
.baseInfo-title {
  min-width: 5em;
}
.content-item {
  line-height: 21px;
  color: #999;
  font-size: 14px;
  margin-bottom: 10px;
}
.content_list > .wechat_title {
  line-height: 32px;
  color: #666;
  font-size: 16px;
}

.reply_card {
  padding: none !important;
}
.reply_box {
  border-bottom: 1px solid #dddddd;
  padding: 20px 20px;
}
.reply_title {
  color: #666;
  font-size: 14px;
  align-items: center;
}
.reply_title_between {
  color: #666;
  font-size: 14px;
  align-items: center;
  justify-content: space-between;
}
.reply-title-text {
  margin-left: 10px;
}
.edit-button {
  margin-left: auto;
}
.reply_content {
  color: #999;
  font-size: 14px;
  min-height: 100px;
  margin-left: 42px;
}
.right {
  width: 560px;
  padding: 20px 0 0 20px;
}
.wechat_card {
  height: 100%;
  width: 530px;
  margin-right: 20px;
}
.menubox {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 530px;
  height: 65px;
  border-top: 1px solid #dddddd;
  line-height: 65px;
}
.menubox > div {
  text-align: center;
  border-right: 1px solid #dddddd;
}
.menubox > div:last-child {
  border-right: none;
}

.navmenu-add {
  position: absolute;
  bottom: 80px;
  font-size: 24px;
}
.navmenu-li {
  border: 1px solid #dddddd;
  border-bottom: 1px solid #d7dde4;
  cursor: pointer;
  background-color: #f4f4f4;
  width: 225px;
  height: 50px;
  line-height: 50px;
  font-size: 17px;
}
.navmenu-small {
  width: 150px;
}
.keyboard {
  width: 80px;
  text-align: center;
}
.keyboard > div {
  margin: 0 auto;
  font-size: 30px;
}
.menu-add {
  font-size: 24px;
}
a {
  color: #687a9e;
  margin-right: 25px;
}
.primarymenu {
  font-size: 18px;
  color: #666;
  justify-content: center;
}
.primarymenu:first-child {
  margin-right: 8px;
}
.navMenu_card_body {
  padding: 20px;
}
.navMenu_card_footer {
  position: absolute;
  height: 50px;
  line-height: 50px;
  width: 580px;
  bottom: 0;
  border-top: 1px solid #dddddd;
  padding-right: 20px;
  justify-content: flex-end;
  align-items: center;
}
.header-button {
  margin-top: -7px;
  margin-left: 20px;
  height: 30px;
  line-height: 18px;
}
/* /deep/ .ivu-card-head {
  padding-top: 20px;
} */
</style>
